'use client';

import Header from '@/components/common/Header';
import Footer from '@/app/homepage/components/Footer';
import PrivacyCookieSettings from '@/components/common/PrivacyCookieSettings';
import { useSiteLanguage } from '@/lib/SiteLanguageContext';

export default function SettingsPage() {
    const { siteLang } = useSiteLanguage();
    return (
        <main className={`min-h-screen no-top-gap bg-white flex flex-col`}>
            <Header />

            <section className="max-w-5xl mx-auto px-4 pt-24 pb-12">
                <h1 className="text-3xl font-bold mb-6">
                    {siteLang === 'en' ? 'Privacy & Cookie Settings' : 'Postavke privatnosti i kolačića'}
                </h1>

                <PrivacyCookieSettings />
            </section>

            <div className="mt-auto">
                <Footer />
            </div>
        </main>
    );
}
